import { render, staticRenderFns } from "./CompetitionEditPrizes.vue?vue&type=template&id=397ff5ee&scoped=true&"
import script from "./CompetitionEditPrizes.vue?vue&type=script&lang=ts&"
export * from "./CompetitionEditPrizes.vue?vue&type=script&lang=ts&"
import style0 from "./CompetitionEditPrizes.vue?vue&type=style&index=0&id=397ff5ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ff5ee",
  null
  
)

export default component.exports